import { BUILDING_NAMES } from '@kaeliux/shared';
import { Icon } from '../ui/Icon';

/** Explains, once per screen, why a plain member sees the Team planet without build or research controls. */
export default function TeamPlanetReadOnlyNotice({ children }: { children?: string }) {
    return (
        <div
            role="note"
            data-testid="team-planet-read-only"
            className="flex items-center gap-3 rounded-panel border border-hairline bg-space-900/80 px-4 py-2.5 text-body text-content-secondary"
        >
            <Icon name="alliance" size={16} aria-hidden="true" className="shrink-0 text-content-muted" />
            <span>
                {children ?? `Your alliance leader and officers manage the Team planet's buildings and research. You can still build ships for your own race in its ${BUILDING_NAMES.shipyard}.`}
            </span>
        </div>
    );
}
